export type NetworkWizardExternalCircle = {
  id: string
  name: string
  slug: string
  /** From search results when available (wizard preview). */
  logoContentUrl?: string
}

export type NetworkWizardFormValues = {
  name: string
  description: string
  /** Raw file for upload; previews use blob URLs (see useObjectUrlForFile). */
  logo?: File | null
  /**
   * Hex color (#RRGGBB). Empty until the wizard mounts, then seeded with a
   * random on-brand color (client-side only, to keep SSR hydration stable).
   */
  primaryColor: string
  address: string
  latitude: string
  longitude: string
  explicitLocationLabel: string
  shareMaterialsWithAllNetworkCommunitiesByDefault: boolean
  managedCircleIris: string[]
  externalCircles: NetworkWizardExternalCircle[]
}

export const defaultNetworkWizardValues: NetworkWizardFormValues = {
  name: '',
  description: '',
  logo: undefined,
  primaryColor: '',
  address: '',
  latitude: '',
  longitude: '',
  explicitLocationLabel: '',
  shareMaterialsWithAllNetworkCommunitiesByDefault: false,
  managedCircleIris: [],
  externalCircles: [],
}
